import { SurveyJSON } from "Survey/types"

const json: SurveyJSON = {
  success: 'Færdig!',
  allowNewCustomer: true,
  errors: {
    required: 'Udfyld venligst dette'
  },
  locales: {
    dk: {
      nextButton: 'Fortsæt',
      nextButtonHint: 'tryk <b>Enter ↵</b>',
      submitButton: 'Indsend',
      textAreaHint: '<b>Shift ⇧</b> + <b>Enter ↵</b> to make a line break',
      invalidEmail: "Email adressen er ugyldig"
    }
  },
  defaultLocale: 'dk',
  items: [
    {
      type: 'custom',
      name: 'header',
      html: 'Velkommen til Revisor1s Afstemningstest for Reconcile skattekonto. Skriv dit svar under hvert spørgsmål. Når du er færdig, trykker du blot på ‘færdig’ knappen, og så modtager vi automatisk dine svar. God fornøjelse!',
      buttonsAlign: 'left',
      buttons: ['next']
    },
    {
      type: 'input',
      name: 'name',
      title: 'Hvad er dit navn',
      required: true,
      placeholder: 'Jens Jensen'
    },
    {
      type: 'input',
      inputType: 'email',
      name: 'email',
      title: 'Hvad er din email adresse?',
      required: true,
      placeholder: 'email@email.com'
    },
    {
      type: 'input',
name: 'hvad_er_en_virksomheds_skattekonto',
title: 'Hvad er en virksomheds Skattekonto?',
required: true,
     
    },
    {
     type: 'input',
name: 'hvorfor_afstemmer_vi_kundernes_skattekonto',
title: 'Hvorfor afstemmer vi kundernes skattekonto?',
required: true,
     
    },
    {
      type: 'input',
name: 'beskriv_startkontrol_i_reconcile_skattekonto',
title: 'Beskriv startkontrol i Reconcile_skattekonto.',
required: true,
      
    },
    {
      type: 'input',
name: 'naevn_to_aarsager_til_manglende_primo_paa_skattekonto_og_loesninger',
title: 'Nævn to årsager til manglende primo på skattekonto og løsninger.',
required: true,
     
    },
    {
      type: 'input',
name: 'hvilke_linjer_bogfoeres_fra_skattekontoen_og_hvornaar_springes_poster_over',
title: 'Hvilke linjer bogføres fra skattekontoen, og hvornår springes poster over?',
required: true,
      
    },
    {
     type: 'input',
name: 'giv_eksempel_paa_skattekonto_post_og_hvilken_konto_som_posten_skal_bogfoeres_paa',
title: 'Giv eksempel på skattekonto-post og hvilken konto som posten skal bogføres på.',
required: true,
     
    },
    {
      type: 'input',
name: 'hvordan_bogfoeres_indbetaling_udbetaling_mellem_bank_og_skattekonto',
title: 'Hvordan bogføres indbetaling/udbetaling mellem bank og skattekonto?',
required: true,
      
    },
    {
      type: 'input',
name: 'hvorfor_modposteres_a_skat_og_am_bidrag_paa_2210_ved_primo_ultimo',
title: 'Hvorfor modposteres A-skat og AM-bidrag på 2210 ved primo/ultimo?',
required: true,
      
    },
    {
      type: 'input',
name: 'hvorfor_bogfoeres_linje_for_linje',
title: 'Hvorfor bogføres linje-for-linje?',
required: true,
     
    },
    {
      type: 'input',
name: 'er_der_lovkrav_til_specifikation_af_skattekonto',
title: 'Er der lovkrav til specifikation af skattekonto?',
required: true,
      
    },
    {
      type: 'input',
name: 'hvordan_haandteres_skats_korrektioner_i_tidligere_perioder',
title: 'Hvordan håndteres SKATs korrektioner i tidligere perioder?',
required: true,
     
    },
    {
      type: 'input',
name: 'hvilke_aarsager_findes_der_til_at_skattekontoen_ikke_stemmer',
title: 'Hvilke årsager findes der til at skattekontoen ikke stemmer?',
required: true,
      
    },
    {
      type: 'input',
name: 'hvilken_periode_vedroerer_skats_opkraevninger_d_17_januar',
title: 'Hvilken periode vedrører SKATs opkrævninger d. 17. Januar?',
required: true,
    },
    {
     type: 'input',
name: 'hvordan_bogfoeres_indbetalinger_udbetalinger_til_fra_skattekonto_hvis_beloebet_ikke_findes_i_banken',
title: 'Hvordan bogføres indbetalinger/udbetalinger til/fra Skattekonto, hvis beløbet ikke findes i banken?',
required: true,
    },
    {
     type: 'input',
      name: 'Hvordan_bogføres_opkrævning_af_A_conto_skat_på_skattekonto? ',
      title: ' Hvordan bogføres opkrævning af A conto skat på skattekonto? ',
      required: true,

},
    {
      
      type: 'input',
name: 'er_oelafgift_fradragsberettiget_ja_nej',
title: 'Er ølafgift fradragsberettiget? (Ja/Nej)',
required: true,
    },
    {
      type: 'input',
name: 'hvordan_haandterer_du_en_situation_hvor_skat_har_bogfoert_tilbage_i_tid_og_aendret_primo_saldoen',
title: 'Hvordan håndterer du en situation, hvor SKAT har bogført tilbage i tid og ændret primo-saldoen?',
required: true,
    },
    {
      type: 'input',
name: 'hvordan_haandterer_du_en_skattekonto_postering_som_er_betalt_af_et_tilknyttet_selskab_dvs_ikke_fundet_i_banken',
title: 'Hvordan håndterer du en skattekonto-postering, som er betalt af et tilknyttet selskab (dvs. Ikke fundet i banken)?',
required: true,
    },
    {
      type: 'input',
name: 'hvad_sker_der_paa_skattekontoen_naar_en_virksomhed_ikke_har_indberettet_a_skat_og_am_til_tiden',
title: 'Hvad sker der på skattekontoen når en virksomhed ikke har indberettet A-skat og AM, til tiden?',
required: true

  },
    {
     type: 'input',
      name: 'Hvad_kan_SKAT_opkræve_på_skattekontoen_udover_moms_A-skat_og_AM-bidrag?',
      title: ' Hvad kan SKAT opkræve på skattekontoen udover moms A-skat og AM-bidrag? ? ',
      required: true,

    },
    {
      type: 'custom',
      name: 'submit',
      html: '<blockquote>Tryk "indsend" for at sende os svarene.</blockquote>',
      buttons: ['submit']
    }
  ]
}

export default json
